import { useEffect } from "react";

/**
 * Hook to disable right-click context menu in PWA mode
 * This prevents Chrome's default context menu from appearing
 * when the app is installed as a PWA
 */
export const usePWAContextMenu = () => {
  useEffect(() => {
    // Check if app is running in standalone mode (installed PWA)
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    if (!isStandalone) {
      return; // Only disable in PWA mode
    }

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Disable right-click context menu
    document.addEventListener("contextmenu", handleContextMenu, true);

    // Also prevent long-press context menu on touch devices
    const handleTouchStart = (e: TouchEvent) => {
      if (e.touches.length > 1) return; // Allow multi-touch gestures
      
      const target = e.target as HTMLElement;
      // Allow context menu on input fields for copy/paste
      if (
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable
      ) {
        return;
      }
    };

    document.addEventListener("touchstart", handleTouchStart, { passive: true });

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu, true);
      document.removeEventListener("touchstart", handleTouchStart);
    };
  }, []);
};
